import React from 'react';
import type { MenuNode } from '@milanote/roma/application';
import { ActionMenu } from '@milanote/roma/application';
import { useSheetClose } from '@milanote/roma';

type MobileRomaMenuProps = {
    ariaLabel: string;
    nodes: MenuNode[];
    showIcons?: boolean;
};

/** Adds mobile sheet dismissal while preserving the shared Roma menu presentation. */
const withMobileSheetPresentation = (nodes: MenuNode[], closeSheet: () => void): MenuNode[] =>
    nodes.map((node) => {
        if (node.type === 'divider') return node;

        return {
            ...node,
            children: node.children ? withMobileSheetPresentation(node.children, closeSheet) : undefined,
            onAction: node.onAction
                ? () => {
                      node.onAction?.();
                      if (!node.keepOpenOnSelect) closeSheet();
                  }
                : undefined,
        };
    });

/** Renders resolved menu nodes with the shared Roma context-menu component inside a mobile sheet. */
const MobileRomaMenu: React.FC<MobileRomaMenuProps> = ({ ariaLabel, nodes, showIcons = false }) => {
    const closeSheet = useSheetClose();
    const mobileNodes = withMobileSheetPresentation(nodes, closeSheet);

    return (
        <ActionMenu.Content
            aria-label={ariaLabel}
            nodes={mobileNodes}
            size="lg"
            className="pb-14"
            showIcons={showIcons}
            showShortcuts={false}
        />
    );
};

export default MobileRomaMenu;
